<template>
  <div>
    <input type="hidden" name="kPI[kpi_source_add]" value="0">
    <div class="form-group">
      <label>{{ __("forms.KPIS.name") }}</label>
      <input type="text" v-model="kpi.name" class="form-control" required name="kPI[name]" :disabled="is_archived" />
    </div>
    <div class="form-group">
      <label>{{ __("forms.KPIS.measuers_and_formulas") }}</label>
      <textarea v-model="kpi.measures_and_formulas" class="form-control" name="kPI[measures_and_formulas]" :disabled="is_archived"></textarea>
    </div>
    <div class="form-group">
      <label>{{ __("forms.KPIS.unit_measure") }}</label>
      <input type="text" v-model="kpi.unit_measure" class="form-control" name="kPI[unit_measure]" :disabled="is_archived"/>
    </div>

    <div class="form-group">
      <label>{{ __("forms.KPIS.classification") }}</label>
      <select class="form-control" name="kPI[kpi_classification_id]" v-model="kpi.kpi_classification_id" :disabled="is_archived">
        <option value="">
          {{ __("forms.EvaluationChart.questions.questions_setting.question12.no_classification") }}
        </option>
        <optgroup :label="type.name" v-for="type in classification_types" v-bind:key="type.id">
          <option v-for="classification in kpi_classifications" v-if="classification.type == type.id"
            :value="classification.id" v-bind:key="classification.id">
            {{ classification.name }}
          </option>
        </optgroup>
        <option v-for="classification in kpi_classifications" v-if="classification.type == 0" :value="classification.id"
          v-bind:key="classification.id">
          {{ classification.name }}
        </option>
      </select>
    </div>

    <div class="form-group">
      <label>Gruppo Segmentazione Kpi</label>
      <select class="form-control" name="kPI[kpi_segment_group_id]" @change="getSegments(kpi.kpi_segment_group_id)"
        required v-model="kpi.kpi_segment_group_id" :disabled="is_archived">
        <option v-for="group in segments_groups" :value="group.id">
          {{ group.name }}
        </option>
      </select>
    </div>
    <div class="form-group">
      <label>Segmentazione</label>
      <select class="form-control" name="kPI[kpi_segment_id]" required v-model="kpi.kpi_segment_id"
        @change="getSegmentGoals(kpi.kpi_segment_id)" :disabled="is_archived">
        <option v-for="segment in segments" :value="segment.id">
          {{ segment.name }}
        </option>
      </select>
    </div>

    <div class="form-group">
      <label>Tipo segmentazione: {{ typologyLabel }}</label>
      <a :href="'/kpis-segments/' + kpi.kpi_segment_id" target="_blanck">
        <i class="far fa-external-link-alt"></i>
      </a>
      <br />
      <label>Calcolo automatico performance:
        {{ automaticPercentageCalculationLabel }}</label>
    </div>
    <div class="form-group">
      <label>Target</label>
      <div v-if="typology == 'number' && automatic_percentage_calculation">
        <input name="kPI[target]" type="number" required class="form-control" step="0.01" v-model="kpi.target" :disabled="is_archived" />
      </div>
      <div v-else>
        {{ targetValue }}
        <input name="kPI[target]" type="hidden" :value="kpi.target" :disabled="is_archived" />
      </div>
    </div>

    <div class="form-group" v-if="showSegmentationDirection">
      <label>{{ __("forms.KPISegments.direction_segmentation") }}:</label>
      <select class="form-control" v-model="kpi.kpi_segment_goal_direction" required
        name="kPI[kpi_segment_goal_direction]" :disabled="is_archived">
        <option value="increment"> {{ __("forms.KPISegments.direction_segmentation_increment") }}</option>
        <option value="decrement"> {{ __("forms.KPISegments.direction_segmentation_decrement") }}</option>
      </select>
    </div>
    <div v-else>
      <div v-if="model_persisted">
        <label>{{ __("forms.KPISegments.direction_segmentation") }}:</label>
        <input type="hidden" name="kPI[kpi_segment_goal_direction]" v-model="kpi.kpi_segment_goal_direction" :disabled="is_archived">
        <label v-if="kpi.kpi_segment_goal_direction === 'increment'">
          {{ __("forms.KPISegments.direction_segmentation_increment") }}
        </label>
        <label v-if="kpi.kpi_segment_goal_direction === 'decrement'">
          {{ __("forms.KPISegments.direction_segmentation_decrement") }}
        </label>
      </div>
    </div>
    <div class="form-group">
      <label> Data approvazione</label>
      <input type="date" class="form-control" name="kPI[approved_at]" v-model="todayDate" :disabled="is_archived"/>
    </div>
    <!--        :href="'/kpi-targets/' + kpi.id + '/kpi'"-->
    <div v-if="model_persisted">
      <a href="#" @click="openModalConsumptives(kpi)" class="btn btn-primary">{{ __("forms.KPIS.consumptives") }}</a>
    </div>
    <div v-else>
      <div class="form-group">
        <input type="checkbox" value="1" name="addFirstTarget" v-model="addFirstTarget" :disabled="is_archived" />
        <label>{{ __("forms.KPI.addFirstConsumptive") }}</label>
      </div>
      <div v-if="addFirstTarget">
        <!--          -->
        <div class="form-group">
          <label>{{ __("forms.kPITarget.identifier") }}</label>
          <select @change="getKpiTargetIdentifier($event)" name="kPITarget[identifier_id]" required
            class="form-control" :disabled="is_archived">
            <option value="">---</option>
            <option v-for="target in target_identifiers" :value="target.id" @change="getKpiTargetIdentifier($event)">
              {{ target.name }}
            </option>
          </select>
        </div>

        <div class="form-group">
          <label>{{ __("forms.kPITarget.expires_at") }}</label>
          <input type="date" class="form-control" name="kPITarget[expires_at]" :value="expiredAtConsumptive" :disabled="is_archived"/>
        </div>

        <div class="form-group">
          <label>{{ __("forms.kPITarget.consumptive") }}</label>
          <div v-if="typology == 'number'">
            <input type="number" class="form-control" name="kPITarget[consumptive]" step="0.01" required :disabled="is_archived" />
          </div>
          <div v-else-if="typology == 'date'">
            <input type="date" class="form-control" name="kPITarget[date_consumptive]" required :disabled="is_archived" />
          </div>
          <div v-else-if="typology == 'text'">
            <select name="kPITarget[text_consumptive_id]" required class="form-control" :disabled="is_archived">
              <option v-for="goal in text_goals" :value="goal.id">
                {{ goal.name }}
              </option>
            </select>
          </div>
        </div>
        <!--          -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    this.kpi = this.kpi_data;
    //set ML
    this.kpi.name = (this.kpi.name == null) ? "" : JSON.parse(this.kpi.name)[this.locale];
    this.kpi.unit_measure = (this.kpi.unit_measure == null) ? "" : JSON.parse(this.kpi.unit_measure)[this.locale];
    this.kpi.measures_and_formulas = (this.kpi.measures_and_formulas == null) ? "" : JSON.parse(this.kpi.measures_and_formulas)[this.locale];
    this.todayDate = (this.kpi.approved_at == null) ? new Date().toISOString().slice(0, 10) : this.kpi.approved_at.slice(0, 10);

    if (this.kpi.kpi_segment_group_id != null) {
      this.getSegments(this.kpi.kpi_segment_group_id);
    }
    if (this.kpi.kpi_segment_id != null) {
      this.getSegmentGoals(this.kpi.kpi_segment_id);
    }
  },
  props: {
    kpi_data: {
      type: [Array, Object],
      required: true,
    },
    model_persisted: {
      type: Boolean,
      required: true,
    },
    model_segments: {
      type: String,
      required: true,
    },
    kpi_classifications: {
      type: Array,
      required: true,
    },
    classification_types: {
      type: Array,
      required: true,
    },
    locale: {
      type: String,
      required: true,
    },
    segments_groups: {
      type: Array,
      required: true,
    },
    target_identifiers: {
      type: Array,
      required: true,
    },
    is_archived: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      kpi: {},
      todayDate: null,
      segments: [],
      text_goals: [],
      typology: "number",
      automatic_percentage_calculation: true,
      targetValue: 0,
      addFirstTarget: 0,
      typologyLabel: "",
      showSegmentationDirection: 0,
      automaticPercentageCalculationLabel: "",
      expiredAtConsumptive: null,
    };
  },
  methods: {
    openModalConsumptives(kpi) {

      app.__vue__.$refs.vue_popup.toggle('KPI', '/kpi-targets/' + kpi.id + '/kpi');
    },
    getSegments(segment_group_id) {
      let url =
        "/kpis-segments-by-kpi-segment-group/" + segment_group_id + "/group";
      let params = {};

      axios
        .get(url, {})
        .then((response) => {
          this.segments = response.data;
        })
        .catch(function (error) {
          alert(error);
        });
    },

    getKpiTargetIdentifier(event) {

      let target_identifier_id = event.target.value;
      if (target_identifier_id === "") {
        return;
      }
      let url = "/kpi-targets-identifier/" + target_identifier_id + "/info";
      axios
        .get(url, {})
        .then((response) => {
          this.expiredAtConsumptive = response.data.expires_at;
        })
    },
    getSegmentGoals(segment_id) {
      let url = "/kpi-segments-goals/" + segment_id + "/kpi-segment-id";
      let params = {};

      axios
        .get(url, {})
        .then((response) => {
          this.text_goals = response.data.goals;
          this.typology = response.data.typology;
          this.targetValue = response.data.targetValue;
          this.automatic_percentage_calculation =
            response.data.automatic_percentage_calculation;
          this.typologyLabel = response.data.typologyLabel;
          this.automaticPercentageCalculationLabel =
            response.data.automaticPercentageCalculationLabel;
          if (!this.automatic_percentage_calculation) {
            this.kpi.target = 0;
          }
          //hide - show direction
          this.showSegmentationDirection = this.automatic_percentage_calculation
        })
        .catch(function (error) {
          alert(error);
        });
    },
  },
};
</script>

<style></style>
